module.exports={
	"title": "Steps to book your repair",
	"steps": [
		{
			"title": "Step 1",
			"description": "Choose your product",
			"image": "intro-step1.png"
		},
		{
			"title": "Step 2",
			"description": "Troubleshoot the issue",
			"image": "intro-step2.png"
		},
		{
			"title": "Step 3",
			"description": "Enter your product details",
			"image": "intro-step4.png"
		},
		{
			"title": "Step 4",
			"description": "Book the repair",
			"image": "intro-step5.png"
		}
	],
	"xxx": "copy end"
}